import { useContext, Context } from 'react';
import _noop from 'lodash/noop';

export const emptyTasksContext = {
    sendTaskEvent: _noop,
    taskMachineService: {
        send: _noop,
        subscribe: () => ({
            unsubscribe: _noop,
        }),
    } as TaskMachineService,
    taskMachineState: {} as TaskMachineState,
};

/**
 * This hook is meant to be extended on a per-React app basis. We have to do this because a React
 * Context is a singleton; there should be one per Provider instance within a React tree.
 * @param tasksContext - the Context value returned by calling React.useContext() with an
 * object that matches the {@link TaskProviderValue} schema. See the
 * {@link https://reactjs.org/docs/hooks-reference.html#usecontext | useContext docs}.
 * @returns an {@link TasksProviderValue} object
 */
export const useTasksBase = (
    tasksContext: Context<TasksProviderValue>,
): TasksProviderValue => {
    if (tasksContext === null || tasksContext === undefined) {
        return emptyTasksContext;
    }

    return useContext(tasksContext);
};
